import { call, put, takeLatest } from "redux-saga/effects";
import { getProjectAllocationDetails, getProjectAllocationSummary } from "../http/requests/project-allocation";
import {
  ProjectAllocationType,
  setProjectAllocationData,
  setVtrackLoader,
  setEmployeeViewData,
  setProjectAllocationSummary,
} from "../redux/actions";

function* workerProjectAllocationSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    //yield put(setProjectAllocationData([]));
    const projectAllocationDetails = yield call(
      getProjectAllocationDetails,
      payload.pageNo,
      payload.pageSize,
      payload.sortDir,
      payload.sortBy,
      payload.searchData,
      payload.status,
      payload.employeeID
    );
    if (payload.employeeView){
      yield put(setEmployeeViewData(projectAllocationDetails));
    }
    else{
      yield put(setProjectAllocationData(projectAllocationDetails));
    }
    yield put(setVtrackLoader(false));
  } catch (err) {
    console.log(err);
    yield put(setVtrackLoader(false));
  }
}

function* workerProjectAllocationSummarySaga({ payload }) {
  try {
    const summaryData = yield call(getProjectAllocationSummary, payload);
    yield put(setProjectAllocationSummary(summaryData));
  } catch (err) {
    console.log(err);
    yield put(setProjectAllocationSummary(null));
  }
}

export function* projectAllocationSaga() {
  yield takeLatest(
    ProjectAllocationType.GET_PROJECT_ALLOCATION_DATA,
    workerProjectAllocationSaga
  );
}

export function* projectAllocationSummarySaga() {
  yield takeLatest(
    ProjectAllocationType.GET_PROJECT_ALLOCATION_SUMMARY,
    workerProjectAllocationSummarySaga
  );
}
